export default __webpack_public_path__ + "static/media/bglt.19d8bea2.svg";